export function formatUsd(amount: number): string {
  return amount.toFixed(2)
}
